import { useState } from 'react';
import { GraduationCap } from 'lucide-react';
import { Modal } from '../Modal/Modal';
import { useTutorialStore } from '../../stores/tutorialStore';
import { useEinfuehrungStore } from '../../stores/einfuehrungStore';
import './TutorialSchalter.css';

/**
 * Der Doktorhut in der Kopfzeile — wie im Event Manager.
 *
 * Der Klick schaltet bewusst nicht sofort um, sondern öffnet ein kleines
 * Fenster: Sonst wären die Erklärungen weg, bevor jemand versteht, was der
 * Knopf überhaupt tut. Von hier lässt sich auch der Rundgang neu starten.
 */
export function TutorialSchalter() {
  const [offen, setOffen] = useState(false);
  const { an, umschalten } = useTutorialStore();
  const begruessungZeigen = useEinfuehrungStore((s) => s.begruessungZeigen);

  return (
    <>
      <button
        type="button"
        className={`theme-toggle tutorial-toggle${an ? ' active' : ''}`}
        onClick={() => setOffen(true)}
        title="Tutorial-Modus: Erklärungen und Einführung"
        data-tour="kopf-doktorhut"
        aria-label="Tutorial-Modus: Erklärungen und Einführung"
      >
        <GraduationCap size={18} aria-hidden="true" />
      </button>

      <Modal isOpen={offen} onClose={() => setOffen(false)} title="Tutorial-Modus" size="sm">
        <p className="tut-text">
          Im Tutorial-Modus steht oben auf jeder Seite ein Kasten, der erklärt, wofür die Seite da
          ist, was Du dort tust und worauf Du achten musst. Darin steckt auch eine kurze Tour durch
          die jeweilige Seite.
        </p>

        <div className="seg-control tut-wahl" role="group" aria-label="Erklärkästen">
          <button
            type="button"
            className={`seg-btn${an ? ' active' : ''}`}
            aria-pressed={an}
            onClick={() => { if (!an) void umschalten(); }}
          >
            Eingeschaltet
          </button>
          <button
            type="button"
            className={`seg-btn${!an ? ' active' : ''}`}
            aria-pressed={!an}
            onClick={() => { if (an) void umschalten(); }}
          >
            Ausgeschaltet
          </button>
        </div>

        <ul className="tut-hinweise">
          <li>Die Einstellung gilt für Dich, nicht für die anderen im Team.</li>
          <li>Einzelne Kästen kannst Du über den Pfeil zuklappen, ohne alles abzuschalten.</li>
          <li>Der Mail-Assistent erklärt jeden Schritt auch bei ausgeschaltetem Tutorial-Modus.</li>
        </ul>

        <div className="tut-tour">
          <p className="tut-tour-text">
            Den Rundgang durch das Mailtool startest Du über „Einführung" oben in der
            Kopfzeile — oder direkt von hier.
          </p>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => { setOffen(false); begruessungZeigen(); }}
          >
            Einführung erneut ansehen
          </button>
        </div>
      </Modal>
    </>
  );
}
